import { useEffect } from 'react';
import { usersActions } from '../../store/users/slice';
import styles from './UserConsole.module.scss';
import { UsersTable } from './components/UsersTable/UsersTable';
import { Button, Icon, Text } from 'components';
import { useDevice } from 'hooks';
import { appActions } from 'store/app/slice';
import { getUsers } from 'store/users/selectors';
import { useDispatch, useSelector } from 'store/utils';

export const UserConsole = () => {
  const users = useSelector(getUsers);

  const { isTablet } = useDevice();

  const dispatch = useDispatch();

  const onOpenCreateUserModalHandler = () => {
    dispatch(appActions.setIsModalOpened({ name: 'createUser', isOpened: true }));
  };

  useEffect(() => {
    const updateData = () => {
      if (document.visibilityState === 'visible') {
        dispatch(usersActions.getUsers());
      }
    };

    window.addEventListener('visibilitychange', updateData);

    return () => window.removeEventListener('visibilitychange', updateData);
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text type="h4" className={styles.title}>
          User Console
        </Text>
        <Button onClick={onOpenCreateUserModalHandler} className={styles.createUserButton} isSmall={isTablet}>
          <Icon name="Plus" />
        </Button>
      </div>
      <UsersTable users={users} />
    </div>
  );
};
